import { Select, Button } from 'antd';
import type { SelectProps } from 'antd';
import './index.scss';

const Pagination = props => {
    // Backward compatible: pages that don't pass pageSize keep the original 10-per-page behaviour.
    const pageSize = Number(props.pageSize) > 0 ? Number(props.pageSize) : 10;
    const total = Number(props.total) || 0;
    const options: SelectProps['options'] = [];
    const pageTotal = total < 1 ? 1 : Math.ceil(total / pageSize);
    for (let i = 0; i < pageTotal; i++) {
        options.push({
            value: (i + 1).toString(),
            label: i + 1,
        });
    }

    const handleChange = (value: string) => {
        props.pageChange(Number(value));
    };

    const start = total === 0 ? 0 : (props.pageNo - 1) * pageSize + 1;
    const end = Math.min(props.pageNo * pageSize, total);

    // Only render the page-size selector when the host page opts in (passes onPageSizeChange).
    const sizeOptions: SelectProps['options'] = (props.pageSizeOptions ?? [10, 20, 50]).map((n: number) => ({
        value: n.toString(),
        label: `${n} / page`,
    }));

    const suffixIcon = (
        <img src={require('@/assets/images/select-icon.png')} alt="" style={{ width: 16, height: 16 }} />
    );

    return (
        <div className="pagination flex-between">
            <div className="total">
                {start} - {end} of {total}
            </div>
            <div className="flex-center">
                {props.onPageSizeChange ? (
                    <div className="pageNum-box flex-center" style={{ marginRight: 12 }}>
                        <Select
                            value={pageSize.toString()}
                            suffixIcon={suffixIcon}
                            style={{ width: 96 }}
                            onChange={(value: string) => props.onPageSizeChange(Number(value))}
                            options={sizeOptions}
                        ></Select>
                    </div>
                ) : null}
                <div>The page you are on</div>
                <div className="pageNum-box flex-center">
                    <Select
                        value={props.pageNo.toString()}
                        suffixIcon={suffixIcon}
                        style={{ width: 67 }}
                        onChange={handleChange}
                        options={options}
                    ></Select>
                </div>
                <div className="left-icon flex-center">
                    <Button
                        className="r-center"
                        disabled={props.pageNo === 1}
                        icon={<span className="pageBtnIcon"></span>}
                        onClick={() => {
                            props.pageChange(props.pageNo - 1);
                        }}
                    />
                </div>
                <div className="right-icon flex-center">
                    <Button
                        className="r-center"
                        disabled={props.pageNo === pageTotal}
                        icon={<span className="pageBtnIcon next_icon"></span>}
                        onClick={() => {
                            props.pageChange(props.pageNo + 1);
                        }}
                    />
                </div>
            </div>
        </div>
    );
};
export default Pagination;
